import {Component, inject, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {ConfigService, TjKeycloakService} from '../../../../core/services';

@Component({
  selector: 'tj-app-configurations-page',
  templateUrl: './app-configurations-page.component.html',
  styleUrls: ['./app-configurations-page.component.scss'],
})
export class AppConfigurationsPageComponent implements OnInit {
  public configService = inject(ConfigService);
  private keycloakService = inject(TjKeycloakService);
  items: MenuItem[] = [];

  ngOnInit(): void {
    if (
      this.configService.isEnabledTerritory() &&
      this.keycloakService.hasRole('TERRITORY_MANAGEMENT_VIEW')
    ) {
      if (this.keycloakService.hasRole('AREA_APP_LINK_RECEIVE_VIEW')) {
        this.items.push({label: 'Receive App Link', routerLink: 'main', icon: 'pi pi-fw pi-envelope'});
      }
      if (this.keycloakService.hasRole('AREA_APP_SURCHARGE_EDIT')) {
        this.items.push({label: 'Area Surcharge', routerLink: 'area-surcharge', icon: 'pi pi-fw pi-map'});
      }
    }
  }
}
